// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputGroupPanel--wrapper"};